module.exports = __webpack_public_path__ + "media/images/ifutur-matrix-badfb0cb4ec7c6da39c80febcc78d514.png";